// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"FooterContainerStyles_footerContainer__1-fTn"};